import React, { Component } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'

import {
  getQuoteValue,
  getBestProgramValue,
  getQuoteDirty,
  getBestProgram,
} from 'selectors/quoteSelectors'
import { getProgramInfo } from 'actions/quoteActions'

import ContractDetails from './ContractDetails'

import './ProgramInfo.scss'

// TODO this acts almost exclusively as a hydrator for ContractDetails

class ProgramInfo extends Component {
  constructor(...args) {
    super(...args)

    this.state = { printOk: true }

    this.print = () => {
      if (!this.state.printOk) return

      this.props.autoPrint &&
        this.setState({ printOk: false }, () => window.print())
    }
  }

  static getDerivedStateFromProps({ programInfo }) {
    return { programInfo }
  }

  getInfo(prevProps = {}) {
    let {
      vehicleId,
      quoteId,
      mode,
      hasTaxes,
      rebatesLoaded,
      bestProgram,
      programInfo,
      getProgramInfo,
    } = this.props

    if (
      hasTaxes &&
      rebatesLoaded &&
      bestProgram &&
      !isEqual(bestProgram, prevProps.bestProgram) &&
      isEmpty(programInfo)
    ) {
      getProgramInfo(vehicleId, quoteId, mode).then(() =>
        setTimeout(this.print, 1000),
      )
    } else if (!isEmpty(programInfo)) {
      setTimeout(this.print, 1000)
    }
  }

  componentDidMount() {
    this.getInfo()
  }

  componentDidUpdate(prevProps) {
    this.getInfo(prevProps)
  }

  componentWillUnmount() {
    this.setState({ printOk: false })
  }

  render() {
    if (!this.props.hasTaxes || !this.props.rebatesLoaded) return null

    return (
      <div className={c('program-info', this.props.className)}>
        <ContractDetails {...this.props} />
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    isDirty: getQuoteDirty(state, op.vehicleId, op.quoteId),
    bestProgram: getBestProgram(state, op.vehicleId, op.quoteId, op.mode),
    hasPrograms: !isEmpty(
      getQuoteValue(state, op.vehicleId, op.quoteId, 'programs'),
    ),
    hasTaxes: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'programsHaveTaxes',
    ),
    rebatesLoaded: !isEmpty(
      getQuoteValue(
        // TODO this sucks!
        state,
        op.vehicleId,
        op.quoteId,
        'rebateInfo',
      ),
    ),
    programInfo: getBestProgramValue(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
      'programInfo',
      {},
    ),
    programId: getBestProgramValue(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
      'ID',
    ),
  }
}

export default connect(
  mapStateToProps,
  { getProgramInfo },
)(ProgramInfo)
